import ReducerBuilder from 'classes/ReducerBuilder';
import initialState from './initialState';
import {Types} from './actions';

export default ReducerBuilder.make(initialState)
  .forType(Types.FETCH_USER_PROFILE)
  .reduce((state, action) => {
    state.profile = null;
    state.fetching = true;
  })
  .forType(Types.RECEIVED_USER_PROFILE)
  .reduce((state, action) => {
    state.profile = action.profile;
    state.fetching = false;
  })
  .build();



// WEBPACK FOOTER //
// ./public/pages/Profile/reducer.js